import { saveEventHistory } from "./legacyService";

const reportedKeys = new Set<string>();

/** Exposto somente para testes — limpa o cache de deduplicação entre cenários. */
export function __resetTelemetryDedupe(): void {
  reportedKeys.clear();
}

/**
 * Monta a mensagem padronizada de erro para o histórico da regulação.
 * Prefixo "Segurado:" segue o padrão já usado pelos demais eventos.
 */
export function buildErrorMessage(context: string, error: unknown): string {
  const name = (error as { name?: string })?.name ?? "UnknownError";
  const rawMessage = (error as { message?: string })?.message ?? "";
  const message = String(rawMessage).slice(0, 120).trim();
  return `Segurado: ERRO ${context}: ${name}${message ? ` (${message})` : ""}`;
}

/**
 * Registra um erro no histórico (mesmo canal que a operação já lê).
 * Nunca lança: telemetria não pode quebrar o fluxo da chamada.
 * Use { dedupe: true } para erros que chegam em rajada (ex.: exceptions de ICE).
 */
export async function reportError(
  context: string,
  error: unknown,
  sessionId: string,
  options?: { dedupe?: boolean }
): Promise<void> {
  const message = buildErrorMessage(context, error);

  if (options?.dedupe) {
    const key = `${sessionId}|${message}`;
    if (reportedKeys.has(key)) return;
    reportedKeys.add(key);
  }

  try {
    await saveEventHistory(message, sessionId);
  } catch (err) {
    console.warn("[telemetry.reportError] falha ao registrar histórico", err);
  }
}
